import { combineReducers } from "redux";
import { Assessment } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_ASSESSMENT_REQUEST } from "./constants";
import { Action } from "./types";

function item(state: Partial<Assessment> = {}, action: Action): Partial<Assessment> {
  switch (action.type) {
    case getSuccessActionType(FETCH_ASSESSMENT_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_ASSESSMENT_REQUEST:
      return true;
    case getSuccessActionType(FETCH_ASSESSMENT_REQUEST):
    case getFailureActionType(FETCH_ASSESSMENT_REQUEST):
      return false;

    default:
      return state;
  }
}

export const assessment = combineReducers({ item, isFetching });
